"use client";

import { useChainId, useSwitchChain } from "wagmi";

import { getChainConfig, getChainIconUrl, getSwapFactoryAddress } from "@/config/chains/helpers";

import { useOnChangeMap } from "@/lib/hooks/use-on-change-map";

import { useVirtualMachineContext } from "@/subsystems/exchange/virtual-machine-provider";

export function useChainFromUrlParam() {
  const wagmiChainId = useChainId();
  const { switchChain } = useSwitchChain();

  const { ethereumVirtualMachineChainId, setEthereumVirtualMachineChainId } = useVirtualMachineContext();

  function batchUpdateChainIds(val: number) {
    setEthereumVirtualMachineChainId(val);
    switchChain({
      chainId: val,
    });
  }

  useOnChangeMap({ wagmiChainId, ethereumVirtualMachineChainId }, ({ next, isSingleChange, changedKey }) => {
    if (isSingleChange) {
      batchUpdateChainIds(
        // --- if Wagmi changed, push Wagmi -> VM ---
        changedKey === "wagmiChainId"
          ? next.wagmiChainId
          : // --- if VM changed, push VM -> Wagmi ---
            next.ethereumVirtualMachineChainId,
      );
    }
  });

  const chainConfig = getChainConfig(ethereumVirtualMachineChainId);
  const chainName = chainConfig.name;
  const chainFactoryProxyAddress = getSwapFactoryAddress(ethereumVirtualMachineChainId);
  const chainIconUrl = getChainIconUrl(ethereumVirtualMachineChainId);

  return {
    chainConfig,
    chainFactoryProxyAddress,
    chainIconUrl,
    chainId: ethereumVirtualMachineChainId,
    chainName,
    updateChainId: setEthereumVirtualMachineChainId,
  };
}
